var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHuFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 200,
    fill: "#cd2a3e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 200,
    width: 1200,
    height: 200,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 400,
    width: 1200,
    height: 200,
    fill: "#436f4d"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHuFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hu_flag.ddcfb51bd3049f3c4e4f8fecc0714f15.svg";